import {Component, OnInit} from '@angular/core';
import {ApiService, ChatbotDef, ChatbotSettings, ChatbotSettingsUpdate} from "../../../services/api.service";
import {AuthService} from "../../../auth/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {JsonPipe, Location, NgClass, NgForOf, NgIf} from "@angular/common";
import {Observable} from "rxjs";
import {LoaderContainerComponent} from "../../../core/loader-container/loader-container.component";
import {RouteContainerComponent} from "../../../core/route-container/route-container.component";
import {QuickPreviewPanelComponent} from "../../../core/quick-preview-panel/quick-preview-panel.component";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatChipsModule} from "@angular/material/chips";

@Component({
  selector: 'app-chatbot-configure',
  standalone: true,
  imports: [
    JsonPipe,
    LoaderContainerComponent,
    NgIf,
    RouteContainerComponent,
    QuickPreviewPanelComponent,
    ActionsContainerComponent,
    BackButtonComponent,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    NgForOf,
    ReactiveFormsModule,
    NgClass,
    MatCheckboxModule,
    MatChipsModule
  ],
  templateUrl: './chatbot-configure.component.html',
})
export class ChatbotConfigureComponent implements OnInit {

  chatbotUuid?: string
  loader?: Observable<ChatbotDef>
  chatbot?: ChatbotDef
  form?: FormGroup
  ragSearchConfigKeys: string[] = []
  loading: boolean = false
  error?: any

  get settingsGroup() {
    return this.form!.controls['ragSearch'] as FormGroup
  }

  isRagSearchDisabled(collectionName: string) {
    return (this.settingsGroup.controls[collectionName] as FormGroup).controls['disabled'].value
  }

  constructor(
    readonly api: ApiService,
    readonly authService: AuthService,
    readonly activatedRoute: ActivatedRoute,
    readonly fb: FormBuilder,
    readonly router: Router,
    readonly location: Location
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      useSessionHistory: [true, Validators.required],
      maxSessionHistorySize: [50, Validators.required],
      ragSearch: this.fb.group({})
    })
    this.chatbotUuid = this.activatedRoute.snapshot.params['chatbotUuid']
    this.loader = this.api.getChatbot(this.chatbotUuid!)
  }

  save() {
    if (this.form && this.form.valid) {
      const update: ChatbotSettingsUpdate = {
        persistent: false,
        settings:  this.form.value as ChatbotSettings
      }
      this.loading = false
      this.error = undefined
      this.api.setChatbotSettings(this.chatbotUuid!, update).subscribe({
        next: (_) => {
          this.loading = false
          this.location.back()
        },
        error: (err) => {
          this.error = err
          this.loading = false
        }
      })
    }
  }

  onLoadChatbot(cb: ChatbotDef) {
    this.chatbot = cb
    if (cb.settings.ragSearch && this.form) {
      this.ragSearchConfigKeys = Object.getOwnPropertyNames(cb.settings.ragSearch)
      this.ragSearchConfigKeys.forEach(sk => {
        const settingValue = cb.settings.ragSearch[sk]
        const outputFields = settingValue.searchConfig.output_fields || []
        if (!this.settingsGroup.controls[sk]) {
          this.settingsGroup.addControl(sk, this.fb.group({
            disabled: [settingValue.disabled || false],
            ragMinSearchScore: [null, Validators.required],
            searchConfig: this.fb.group({
              limit: [settingValue.searchConfig.limit, Validators.required],
              metric_type: [settingValue.searchConfig.metric_type, Validators.required],
              output_fields: [outputFields],
              output_fields_text: this.fb.control({
                value: outputFields.join(', '), disabled: true
              })
            })
          }))
        }
      })
      this.form.patchValue(cb.settings, {
        emitEvent: true
      })
    }
  }
}
